import React from 'react'



const h1Styles = {fontSize: 45 + 'px', marginLeft: '100px', marginRight: '100px', marginTop: '100px', marginBottom: '0', paddingBottom: '0', letterSpacing: '5px'}
const linkStyles = {fill: 'purple', backgroundColor: "white", fontSize: '40', fontFamily: 'Montserrat Alternates, sans-serif', textDecoration: 'none'}
const textStyles = { fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left', marginLeft: '300px'}
const pStyles = {marginLeft:'230px', marginRight:'230px', marginTop:'100px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}
const liStyles = {marginLeft:'230px', marginRight:'230px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif'}
const itemsStyles = {margin:'10px', fontSize: '25px', fontFamily: 'Montserrat Alternates, sans-serif', textAlign: 'left'}
const imageStyles = {height: '400px', width: '500px',}


const TerminalMusicEditor = () => {

    return (
        <div style={{width: '1000px', zoom: '0.5', textAlign: 'center', margin: '0 auto', position: 'relative'}}>
            
            <h1 style={h1Styles}>Music Editor Terminal App</h1>

            <h2 style={textStyles}>ruby</h2>

            <div style={textStyles}>
            <a style={linkStyles} href='https://github.com/Nickphammond/Terminal-App-Asignment'>check out Github rep</a>
            </div>

            <p style={pStyles}>For those who wish to compose the latest banger but can't afford those super expensive music software programs, 
                here's one that runs right in the humble terminal (Currently only built for MacOS).</p>
                <br></br>
                <img style={imageStyles} src={'images/screen_shot.png'} alt='piano roll'></img>
                <p style={pStyles}>You can:</p>
                <ul style={liStyles}>
                    <li style={itemsStyles}>write music</li>
                    <li style={itemsStyles}>play back music in real time (it even plays chords!)</li>
                    <li style={itemsStyles}>save/export musical composition as a specially formatted text filament</li>
                    <li style={itemsStyles}>load files to be edited during later sessions</li>
                </ul>
            


                {/* <div style={backStyles}>
                <Link to="/">
                    BACK
                </Link>
                </div> */}
        </div>
    )
}

export default TerminalMusicEditor